import React from "react";
import './App.scss';

function ExportButton() {
  return (
    <button className="exportButton">
    종료
    </button>
  )
}

export default ExportButton;